import { render } from "./CustomMappingModal.vue?vue&type=template&id=249e5d85&ts=true"
import script from "./CustomMappingModal.vue?vue&type=script&lang=ts"
export * from "./CustomMappingModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__